module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-theme-2-9e79eb8032b9a7bb47001b6ad896ccb5.webp";